import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import parse from 'html-react-parser';

/**
 * @typedef Member
 * @property {string} name
 * @property {string} detailPostfix
 * @property {string} title
 * @property {string} photoFilename
 */

class TeamV2 extends Component {
  publicUrl = process.env.PUBLIC_URL + '/'

  members = [
    {
      name: 'Gavin Liu',
      detailPostfix: 'gavin_liu',
      title: 'Sales Director',
      photoFilename: 'gavin_liu.webp',
      email: 'gavin.liu@hoyee.com.au',
      mobile: '0406 679 777',
      introduction:
        '<p>With over 15 years of experience in the real estate and property development industry, Gavin Liu embarked on his career journey with the pioneering property developer Central Equity. Contributed himself for more than a dozen projects throughout Melbourne Regions, encompassing apartments, house and land packages, as well as standalone houses.</p>' +
        '<p>Later, Gavin took on the role of Head of the Asian market at Samma Group, one of Victoria\'s top 5 developers. This position provided him with invaluable insights into business management, particularly in the domains of sales and marketing. His profound knowledge of property investment has facilitated numerous successful transitions for individuals settling into their new homes across the Victoria Metro Area.</p>' +
        '<p>Skilled at conducting lively, effective approaches Gavin\'s clients have come to appreciate his uncanny ability to extract the absolute maximum possible value for each and every property that he handles. His intuitive understanding of buyer motivations combined with a personable but firm negotiation style inevitably leads to benchmark prices being achieved.</p>' +
        '<p>As a sales director of Hoyee Property Group, Gavin takes personal pride in, and contributes enormous individual energy to providing each and every client with a rewarding real estate experience.</p>'
    },
    {
      name: 'Michelle Luo',
      detailPostfix: 'michelle_luo',
      title: 'Property Specialist',
      photoFilename: 'michelle_luo.webp',
      email: 'michelle.luo@hoyee.com.au',
      mobile: '0412 568 136',
      introduction:
        '<p>Meet Michelle Luo, an experienced property specialist at Hoyee Property Group with years of accounting and real estate expertise. Fluent in English, Mandarin, and Cantonese, she offers a unique edge in serving diverse clientele.</p>' +
        '<p>Michelle\'s unwavering dedication ensures personalized and professional service that exceeds expectations. She believes in tailoring experiences to the individual needs and aspirations of clients.</p>' +
        '<p>Her mission is guiding clients through significant real estate decisions, whether finding their dream home or selling a property. She simplifies complex processes, making them smooth, stress-free, and ultimately rewarding.</p>' +
        '<p>Michelle\'s passion extends beyond properties to the people she serves. Her genuine love for service drives her to make a positive impact on clients\' lives, helping them achieve their real estate goals."</p>'
    },
    {
      name: 'Ying Zheng',
      detailPostfix: 'ying_zheng',
      photoFilename: 'ying_zheng_1046-1320.jpg',
      title: 'Operation Manager',
      email: 'admin@hoyee.com.au',
      mobile: '0413 936 690',
      introduction:
        '<p>Ying joined the real estate industry after graduate from university in 2013. Been working for an industry-leading property development company in Melbourne for 8 years, she has extensive experience in administration roles at different departments including but not limited to sales, marketing, telemarketing, data entry, project management, conveyancing etc, her experience in various aspects of the industry is truly valuable. Not only does she sit in the office and manage the day-to-day operations of the office, but Ying also frequently flies interstate and overseas to the frontline providing administration support to the sales team and immediate response to clients.</p>' +
        '<p>After giving birth to her first baby in 2021, Ying took a break from work and started her new role in motherhood.</p>' +
        '<p>In 2022, Ying returned to the workforce and Joined Hoyee Property Group as Operation Manager. She oversees the daily office operations and simultaneously contributes her experience to advancing the company’s marketing strategies and enhancing customer communication. She plays a crucial role in supporting the team to uphold the highest standard of excellence and professionalism.</p>',
    },
  ]

  photoMember = this.members.filter(member => member.photoFilename);
  noPhotoMember = this.members.filter(member => !member.photoFilename);

  /**
   * @param member {Member}
   * @param index {number}
   * @returns {JSX.Element}
   */
  teamMemberCard (member, index) {
      return (
    <div className="col-lg-6 col-sm-12" key={index}>
          <Link to={`/team-details?${member.detailPostfix}`}>
          <div className="ltn__team-item ltn__team-item-3---">
            <div className="row align-items-center">
              <div className="team-info col-lg-8 col-sm-9">
                <h4>{member.name}</h4>
                <h6 className="ltn__secondary-header-color">{member.title}</h6>
              </div>
              {
                member.photoFilename &&
                <div className="team-img col-lg-4 col-sm-3">
                  <img src={this.publicUrl + `assets/img/team/${member.photoFilename}`} alt="Image"/>
                </div>
              }
            </div>
          </div>
          </Link>
        </div>
      )
  }

  render() {
    let publicUrl = process.env.PUBLIC_URL + '/'

    let imagealt = 'image'

    return <div className="ltn__team-area pt-70 pb-90" style={{paddingLeft: '10%', paddingRight: '10%'}}>
			<div className="container">
        <div className="ltn__section-title-2--- mb-20">
          {/*<h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Our Story</h6>*/}
          <h1 className="section-title">
            Our Team
            <span>.</span>
          </h1>
          <p>
            At Hoyee Property Group, we comprise a team of devoted individuals committed to propelling us towards excellence as a distinguished Real Estate Advisory and Property Development Company. Remarkably skilled and innovative professionals form the core of what distinguishes our company as an outstanding partner.
          </p>
          <p>
            Get to know our people.
          </p>
        </div>

        <div className="row justify-content-start go-top">
          {this.photoMember.map((member, index) => this.teamMemberCard(member, index))}
        </div>
        <div className="row justify-content-start go-top">
          {this.noPhotoMember.map((member, index) => this.teamMemberCard(member, index))}
        </div>

        <div className="row">
          <div className="col-lg-12 align-self-center">
            <div className="about-us-img-wrap" style={{paddingBottom: "10px"}}>
              <img src={publicUrl + "assets/img/team/team.webp"} alt="Team Image"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export default TeamV2
